module.exports = __webpack_public_path__ + "fonts/Arial-Rounded-MT-Bold.2d1068a7.ttf";